<!--
 * @Author: 徐艳龙 w17630400757@163.com
 * @Date: 2022-05-07 08:40:45
 * @LastEditors: 徐艳龙 w17630400757@163.com
 * @LastEditTime: 2022-05-23 09:49:18
 * @FilePath: \Home\Transfor-website\src\components\pc\Main.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="main">
    <router-view />
  </div>
</template>
<script>
export default {
  mounted() {
    const auserId = localStorage.getItem('auserId');
    if (!auserId && (this.$router.currentRoute.path == '/pc/Index'|| this.$router.currentRoute.path == '/pc/AddProduct'||this.$router.currentRoute.path == '/pc/Details')) {
      this.$router.push('/pc/login');
    }
  },
};
</script>
<style scoped>
.main {
  width: 100%;
  /* border-top: 1px solid #4d4d4d; */
  background: #f4f4f4;
  z-index: 1;
  /* margin-bottom: 177px; */
}
</style>
